import { gql } from "@apollo/client";

export const GET_TICKET_TYPES = gql`
  query GetTicketTypes($environmentId: Int!) {
    ticketTypes(environmentId: $environmentId) {
      period
      tickets {
        id
        name
        code
        expiresAt
        meta
        environmentId
      }
    }
  }
`;

export const GET_MY_TICKETS = gql`
  query GetMyTickets {
    myTickets {
      period
      tickets {
        bonusTypeId
        name
        code
        totalTickets
        expiresAt
      }
    }
  }
`;

export const PURCHASE_TICKETS = gql`
  mutation PurchaseTickets($bonusTypeId: Int!, $quantity: Int!, $isFree: Boolean!) {
    purchaseTickets(bonusTypeId: $bonusTypeId, quantity: $quantity, isFree: $isFree) {
      tickets {
        bonusTypeId
        name
        code
        period
        totalTickets
        expiresAt
      }
    }
  }
`;
